// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-nav[data-v-8acf389c]{box-shadow:0 -.25rem .625rem rgba(108,117,125,.2)}.b-nav a[data-v-8acf389c]{border-width:1px;--tw-border-opacity:1;border-color:rgb(255 255 255 / var(--tw-border-opacity));fill:transparent;stroke:#adadad}.b-nav a.active[data-v-8acf389c]{position:relative;--tw-bg-opacity:1;background-color:rgb(42 72 84 / var(--tw-bg-opacity));top:-50%}.b-nav a.active svg[data-v-8acf389c]{fill:#ffffff;stroke:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
